import {
  ALTERNATIVE_DESIGNS_EDIT,
  ALTERNATIVE_DESIGNS_RESET_EDITABLE
} from "./mutations.type";


const state = {
  editableDesign: {},
  editableDesignFieldName: ''
};

const getters = {
  editableDesign(state) {
    return state.editableDesign;
  },
  editableDesignFieldName(state) {
    return state.editableDesignFieldName;
  }
};
const actions = {
};

const mutations = {
  [ALTERNATIVE_DESIGNS_EDIT](state, {design, fieldName }) {
    state.editableDesign = JSON.parse(JSON.stringify(design));
    state.editableDesignFieldName = fieldName;
  },
  [ALTERNATIVE_DESIGNS_RESET_EDITABLE](state) {
    state.editableDesign = {};
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
